import { $myFetch } from "."

export const $getWarrantyList = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "warranty",
    {
      headers: myHeaders,
    },
    undefined,
    undefined,
    undefined
  )
}
